module.exports = __webpack_public_path__ + "media/icons/shift-icon-default-d269609d.jpeg";